import { Reducer } from 'interfaces'
import { SetFilterByAccountsAction, ToggleComparisonAction } from 'components/features/pageFilters/actions'
import { PageFiltersPreferencesAppState } from 'components/features/pageFilters/types'
import { SET_MEMBER_INFO } from 'actions/memberActions'

const INIT_STATE = {
  comparison: true,
  disabled_accounts: [],
}
export const pageFiltersReducer: Reducer<PageFiltersPreferencesAppState> = (prevState = INIT_STATE, action) => {
  switch (action.type) {
    case SET_MEMBER_INFO: {
      const { preferences } = action.payload
      if (!preferences) {
        return prevState
      }

      const { are_comparisons_enabled, excluded_account_uids } = preferences.data.filters ?? {}
      return {
        ...prevState,
        comparison: are_comparisons_enabled ?? true,
        disabled_accounts: excluded_account_uids ?? [],
      }
    }

    case ToggleComparisonAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return {
        ...prevState,
        comparison: action.payload.params.isEnabled,
      }
    }

    case SetFilterByAccountsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }
      const { disabled_accounts } = action.payload.response

      return {
        ...prevState,
        disabled_accounts,
      }
    }
  }
  return prevState
}
